// LUMINA · pages/vajra/components/EventDetailModal.jsx
// Phase 39D: extracted from VajraPortal.jsx

import React from 'react';
import { GD, GDB, BG, TXT, TXT2 } from '../constants';
import { feeTag, buildTimeRow } from '../utils';
import { PaymentInfo } from '../primitives';

export default function EventDetailModal({ event, onClose, lang, isLoggedIn, onRegister }) {
  if (!event) return null;
  const zh = lang !== "en";
  const TYPE_ZH = { teaching:"教法", empowerment:"灌顶", puja:"法会/Puja", retreat:"闭关", ritual:"法事", other:"其他" };
  const TYPE_EN = { teaching:"Teaching", empowerment:"Empowerment", puja:"Puja", retreat:"Retreat", ritual:"Ritual", other:"Other" };
  const typeLabel = zh ? (TYPE_ZH[event.event_type]||event.event_type||"活动") : (TYPE_EN[event.event_type]||event.event_type||"Event");
  const title = zh ? (event.title_zh||event.title_en||"法会活动") : (event.title_en||event.title_zh||"Event");
  const subtitle = zh ? event.subtitle_zh : event.subtitle_en;
  const teacher = zh ? (event.teacher_zh||event.teacher_en) : (event.teacher_en||event.teacher_zh);
  const bio = zh ? (event.bio_zh||event.bio_en) : (event.bio_en||event.bio_zh);
  const price = zh ? event.price_info_zh : (event.price_info_en||event.price_info_zh);
  const typeColor = { teaching:"#3b82f6",empowerment:"#dc2626",puja:"#d97706",retreat:"#8b5cf6",ritual:"#10b981",other:"#6b7280" }[event.event_type]||GD;
  let sessions = event.sessions;
  if (typeof sessions === 'string') { try { sessions = JSON.parse(sessions); } catch(e) { sessions = []; } }
  if (!Array.isArray(sessions)) sessions = [];
  const flyer = event.flyer_url || event.flyer_zh || event.flyer_en;

  return (
    <div style={{
      position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:2000,
      display:"flex",alignItems:"center",justifyContent:"center",
    }} onClick={onClose}>
      <div style={{
        background:BG,border:`1.5px solid ${GDB}`,borderRadius:12,
        maxWidth:640,width:"92%",maxHeight:"90vh",overflowY:"auto",
        padding:"2rem",position:"relative",
        boxShadow:"0 8px 40px rgba(139,105,20,0.18)",
        opacity:1,transform:"translateY(0)",
        transition:"opacity 200ms ease,transform 200ms ease",
      }} onClick={e=>e.stopPropagation()}>
        {/* Close */}
        <button onClick={onClose} style={{
          position:"absolute",top:16,right:16,background:"none",border:"none",
          fontSize:20,color:GD,cursor:"pointer",lineHeight:1,padding:4,
        }}>✕</button>

        {/* 1. Type badge + fee badge + date */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
            <span style={{fontSize:11,padding:"3px 10px",borderRadius:10,letterSpacing:1,
              background:`${typeColor}18`,color:typeColor,border:`1px solid ${typeColor}44`}}>
              {typeLabel}
            </span>
            {(()=>{const ft=feeTag(event);return ft?<span style={{fontSize:10,padding:"3px 10px",borderRadius:10,background:ft.bg,color:ft.color,border:`1px solid ${ft.border}`,fontWeight:500}}>{ft.label}</span>:null;})()}
          </div>
          {event.start_date&&<span style={{fontSize:12,color:TXT2,opacity:.7}}>{event.start_date}</span>}
        </div>

        {/* 2. Title */}
        <div style={{fontSize:22,color:TXT,letterSpacing:.5,lineHeight:1.4,marginBottom:4,
          fontFamily:"'Noto Serif SC','Noto Serif',serif"}}>
          {title}
        </div>
        {!zh&&event.title_zh&&<div style={{fontSize:14,color:TXT2,marginBottom:8}}>{event.title_zh}</div>}

        {/* 3. Subtitle */}
        {subtitle&&<div style={{fontSize:14,color:TXT2,fontStyle:"italic",marginBottom:12}}>{subtitle}</div>}

        {/* 4. Teacher */}
        {teacher&&<div style={{fontSize:14,color:GD,marginBottom:8}}>☸ {teacher}</div>}

        {/* Phase 117: credential gate notice */}
        {event.credential_key && (
          <div style={{
            fontSize: 12, marginBottom: 8, padding: "6px 12px",
            background: "rgba(139,105,20,0.06)", borderRadius: 6,
            border: "1px solid rgba(139,105,20,0.2)",
            color: "#8B6914", letterSpacing: .5,
          }}>
            🔑 {zh ? "需要灌顶资格" : "Empowerment required"}: {event.credential_key}
          </div>
        )}

        {/* 5. Location / online */}
        {event.location&&<div style={{fontSize:13,color:TXT2,marginBottom:4}}>📍 {event.location}</div>}
        {event.online_link&&(()=>{
          const isUrl = /^https?:\/\//i.test(event.online_link);
          return isUrl ? (
            <div style={{fontSize:13,marginBottom:8}}>
              🔗 <a href={event.online_link} target="_blank" rel="noopener noreferrer"
                style={{color:"#6366f1",textDecoration:"underline"}}>线上参与</a>
            </div>
          ) : (
            <div style={{fontSize:13,marginBottom:8,padding:"8px 12px",background:"rgba(99,102,241,0.06)",borderRadius:6,border:"1px solid rgba(99,102,241,0.15)"}}>
              💻 {event.online_link}
            </div>
          );
        })()}

        {/* 6. Dates + time + tz conversions (Phase 33) */}
        {event.start_date&&<div style={{fontSize:13,color:TXT2,marginBottom:4}}>
          📅 {event.start_date}{event.end_date&&event.end_date!==event.start_date?` — ${event.end_date}`:""}
        </div>}
        {event.start_time&&(()=>{ const row=buildTimeRow(event.start_time,event.end_time,event.timezone); return row?(
          <div style={{marginBottom:12}}>
            <div style={{fontSize:13,color:TXT,fontWeight:500}}>⏰ {row.fromStr}</div>
            {row.conversions.length>0&&<div style={{fontSize:11,color:TXT2,marginTop:3,letterSpacing:.3}}>
              {row.conversions.join(" · ")}
            </div>}
          </div>
        ):null; })()}
        {event.recurring_rule&&<div style={{fontSize:12,color:TXT2,marginBottom:12,opacity:.7}}>{event.recurring_rule}</div>}

        {/* 7. Cover image + Flyer */}
        {event.cover_image_url && (
          <img src={event.cover_image_url} alt={event.title_zh} style={{width:"100%",borderRadius:8,marginBottom:16,display:"block",maxHeight:300,objectFit:"cover"}}
            onError={e=>{e.currentTarget.style.display="none";}}/>
        )}
        {flyer&&<img src={flyer} alt="法会海报" style={{width:"100%",borderRadius:8,marginBottom:16,display:"block"}}
          onError={e=>{e.currentTarget.style.display="none";}}/>}

        {/* 8. Bio / description */}
        {bio&&<div style={{fontSize:14,color:TXT,lineHeight:1.7,marginBottom:12,whiteSpace:"pre-wrap"}}>{bio}</div>}

        {/* 8a. Phase 115: bilingual event description */}
        {(()=>{
          const desc = zh ? (event.description_zh||event.description_en) : (event.description_en||event.description_zh);
          if (!desc) return null;
          return <div style={{fontSize:14,color:"rgba(0,0,0,0.7)",lineHeight:1.7,marginBottom:12,whiteSpace:"pre-wrap"}}>{desc}</div>;
        })()}

        {/* Requirements */}
        {(()=>{
          let reqs = null;
          try { reqs = typeof event.requirements==="string" ? JSON.parse(event.requirements) : event.requirements; } catch(e){}
          if (!Array.isArray(reqs) || reqs.length===0) return null;
          return (
            <div style={{marginBottom:12,padding:"12px 16px",background:"rgba(220,38,38,0.04)",borderRadius:8,border:"1px solid rgba(220,38,38,0.15)"}}>
              <div style={{fontSize:12,color:"#dc2626",fontWeight:600,letterSpacing:1,marginBottom:8}}>⚠️ 参加要求</div>
              {reqs.map((r,i)=>(
                <div key={i} style={{fontSize:13,color:TXT,lineHeight:1.7,marginBottom:4}}>{r}</div>
              ))}
            </div>
          );
        })()}

        {/* 9. Spiritual function */}
        {event.spiritual_function&&<div style={{marginBottom:12}}>
          <span style={{fontSize:12,padding:"3px 10px",borderRadius:10,
            background:"rgba(184,134,11,0.1)",color:"#B8860B",border:`1px solid rgba(184,134,11,0.3)`}}>
            功能：{event.spiritual_function}
          </span>
        </div>}

        {/* 10. Sessions */}
        {sessions.length>0&&(
          <div style={{marginBottom:12}}>
            <div style={{fontSize:11,color:TXT2,letterSpacing:1.5,textTransform:"uppercase",marginBottom:8}}>课程安排</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:6}}>
              {sessions.map((s,i)=>(
                <div key={i} style={{fontSize:12,color:TXT2,padding:"6px 10px",background:"rgba(212,175,55,0.06)",borderRadius:6}}>
                  {s.date&&<span style={{color:GD,marginRight:8,fontWeight:600}}>{s.date}</span>}
                  {s.title_zh||s.title||""}{s.time?` · ${s.time}`:""}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 11. Price */}
        {(price||event.fee_amount)&&<div style={{fontSize:13,color:TXT,marginBottom:4}}>
          {price}
          {event.donation_type==="fixed"&&event.fee_amount&&
            <span style={{marginLeft:8,color:GD}}>CAD ${event.fee_amount}</span>}
        </div>}

        {/* 12. Payment info */}
        {event.payment_info&&<div style={{fontSize:12,color:TXT2,opacity:.7,marginBottom:8}}>{event.payment_info}</div>}

        <div style={{height:1,background:`rgba(212,175,55,0.2)`,margin:"16px 0"}}/>

        {/* 12b. Payment info */}
        <PaymentInfo ev={event}/>

        {/* 13. Registration button */}
        {event.registration_required ? (
          isLoggedIn ? (
            <button onClick={()=>onRegister&&onRegister({eventId:event.id,eventTitle:event.title_zh||event.title_en,donationType:event.donation_type||"free"})}
              style={{width:"100%",padding:"12px",borderRadius:8,border:"none",
                background:`linear-gradient(135deg,${GD},#A07828)`,color:"#fff",
                fontSize:14,cursor:"pointer",letterSpacing:1}}>
              {zh?"立即报名":"Register"}
            </button>
          ) : (
            <button onClick={onClose}
              style={{width:"100%",padding:"12px",borderRadius:8,border:`1px solid ${GDB}`,
                background:"transparent",color:GD,fontSize:14,cursor:"pointer",letterSpacing:1}}>
              {zh?"登录后报名":"Login to Register"}
            </button>
          )
        ) : (
          <div style={{textAlign:"center",fontSize:13,color:TXT2,padding:"10px",
            background:"rgba(212,175,55,0.06)",borderRadius:8,border:`1px solid rgba(212,175,55,0.2)`}}>
            {zh?"无需报名，欢迎参与":"Open to All — No Registration Required"}
          </div>
        )}
      </div>
    </div>
  );
}
